import { initializeBrowserLogger } from "@agent-todo/shared"
import { StrictMode } from "react"
import { createRoot } from "react-dom/client"

import App from "./App"

initializeBrowserLogger({
  serviceName: "agent-gate-ui",
  betterStackToken: import.meta.env["VITE_BETTER_STACK_LOGS_TOKEN"],
  // Every deploy runs a production build, so MODE alone says "production" on dev too
  environment: import.meta.env["VITE_ENVIRONMENT"] ?? import.meta.env.MODE,
})

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
